import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { Search, Plus } from "lucide-react";
import { GetallProduct, DeleteProduct } from "../api";

function Products() {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  console.log(
    products,
    "productsproductsproductsproductsproductsproductsproductsproductsproductsproducts",
  );
  useEffect(() => {
    fetchProducts();
  }, []);
  const IMAGE_URL =
    process.env.NODE_ENV === "production"
      ? "https://polybionictechnologies.com"
      : "http://localhost:5001";
  const fetchProducts = async () => {
    try {
      const res = await GetallProduct();

      if (res.data.success) {
        setProducts(res.data.products);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deleteProduct = async (id) => {
    if (!window.confirm("Delete Product?")) return;

    try {
      await DeleteProduct(id);

      setProducts(products.filter((item) => item._id !== id));
    } catch (error) {
      console.log(error);
    }
  };

  const filteredProducts = products.filter((item) =>
    item.title?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="bg-white rounded-2xl shadow p-6">
      {/* Header */}
      <div className="flex  grid-cols-2 gap-4 mb-6  justify-between ">
        <div>
          <h2 className="text-2xl sm:text-3xl font-bold">Products</h2>

          <p className="text-sm sm:text-base text-gray-500 mt-1">
            Total Products: {products.length}
          </p>
        </div>

        <div>
          {" "}
          <Link
            to="/dashboard/add-product"
            className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white px-5 py-3 rounded-lg flex items-center justify-center gap-2 transition"
          >
            <Plus size={18} />
            Add Product
          </Link>
        </div>
      </div>

      {/* Search */}
      <div className="relative mb-6">
        <Search size={18} className="absolute left-4 top-4 text-gray-400" />

        <input
          type="text"
          placeholder="Search product..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full border rounded-xl pl-11 pr-4 py-3"
        />
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <div className="overflow-x-auto rounded-xl">
          <table className="min-w-[900px] w-full">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="p-4">Image</th>
                <th className="px-4 py-3">Name</th>
                <th className="px-4 py-3">Category</th>
                <th className="px-4 py-3">Price</th>
                <th className="px-4 py-3">Stock</th>
                <th className="px-4 py-3">Status</th>
                <th className="px-4 py-3 text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredProducts.map((product) => (
                <tr key={product._id} className="border-b hover:bg-gray-50">
                  <td className="p-4">
                    <img
                      src={`${IMAGE_URL}/uploads/${product.image}`}
                      alt={product.title}
                      className="w-14 h-14 rounded-lg object-cover"
                    />
                  </td>

                  <td className="px-4 font-medium whitespace-nowrap">
                    {product.title}
                  </td>

                  <td className="px-4 whitespace-nowrap">{product.category}</td>

                  <td className="px-4 whitespace-nowrap">
                    ₹{product.price?.toLocaleString()}
                  </td>

                  <td className="px-4 text-center">{product.stock}</td>

                  <td className="px-4">
                    {product.stock > 0 ? (
                      <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm whitespace-nowrap">
                        In Stock
                      </span>
                    ) : (
                      <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm whitespace-nowrap">
                        Out of Stock
                      </span>
                    )}
                  </td>

                  <td className="px-4">
                    <div className="flex gap-2 justify-center">
                      <Link
                        to={`/dashboard/edit-product/${product.slug}`}
                        className="bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-lg text-sm"
                      >
                        Edit
                      </Link>

                      <button
                        onClick={() => deleteProduct(product._id)}
                        className="bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded-lg text-sm"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {filteredProducts.length === 0 && (
          <div className="text-center py-10 text-gray-500">
            No products found
          </div>
        )}
      </div>
    </div>
  );
}

export default Products;
